import { CreateTempReplacementInterface } from "../interfaces/TempReplacementInterface/CreateTempReplacementInterface";
import { TempReplacementInterface } from "../interfaces/TempReplacementInterface/TempReplacementInterface";
import BaseService from "./BaseService";

export class TempReplacementService extends BaseService<TempReplacementInterface, CreateTempReplacementInterface>{ 
    constructor(){
        let url: string = '/temp-replacement/admin'
        super(url)
    }
}